import { Loader, klaviyo } from '@services';

class ProductStockNotification extends HTMLElement {
  /** @type {string | undefined} */
  #variantId = this.dataset.variantId;

  /** @type {HTMLFormElement | null} */
  #form = this.querySelector('form');

  /** @type {HTMLElement | null} */
  #alert = this.querySelector('[data-alert]');

  /** @type {InstanceType<typeof Loader> | undefined} */
  #loader;

  connectedCallback() {
    if (!this.#form || !this.#variantId) return;

    this.#loader = new Loader(this);

    this.#form.addEventListener('submit', (event) => this.#onFormSubmit(event));
  }

  disconnectedCallback() {
    this.#loader?.destroy();
  }

  /**
   * Handle form submission.
   * @param {SubmitEvent} event
   * @returns {void}
   */
  #onFormSubmit(event) {
    event.preventDefault();
    const email = event.target.email.value;

    if (this.#alert) {
      this.#alert.className = '';
      this.#alert.textContent = '';
    }

    this.#createSubscription(email);
  }

  /**
   * Create a back-in-stock subscription via Klaviyo and show loader/success/error state.
   * @param {string} email
   * @returns {Promise<void>}
   */
  async #createSubscription(email) {
    this.#loader.show();
    await klaviyo
      .createClientBackInStockSubscription({ email, variantId: this.#variantId })
      .then((message) => {
        this.#onSuccess(message);
      })
      .catch((error) => {
        this.#onError(error);
      })
      .finally(() => {
        this.#loader.hide();
      });
  }

  /**
   * Show success state and remove the form.
   * @param {string} message
   * @returns {void}
   */
  #onSuccess(message) {
    if (!this.#alert) return;
    this.#alert.className = 'form__success';
    this.#alert.textContent = message;
    this.#form?.remove();
  }

  /**
   * Show error state and display the error message.
   * @param {Error} error
   * @returns {void}
   */
  #onError(error) {
    if (!this.#alert) return;
    this.#alert.className = 'form__errors';
    this.#alert.textContent = error.message;
  }
}

customElements.define('product-stock-notification', ProductStockNotification);
